// /* jshint ignore:start */
// (function () {
//     'use strict';
//     angular.module('HeroPRO')
//       .service('productLookupService',

/* @ngInject */
export default function ProductLookupService($timeout, $q, $http, HPConfig, geoStateCacheService) {
    const serviceBase = HPConfig.heroProApi;

    // Product Categories
    const _productCategories = {};
    const _getProductCategories = function (geoState, programId) {
        //should this be a route?
        var _url = `${serviceBase}ProductLookup/GetCategories?geoState=${geoState}&programId=${programId}&includeProductTypes`;
        if (programId === null || programId === 'undefined')
            _url = `${serviceBase}ProductLookup/GetCategories?geoState=${geoState}&includeProductTypes`;
        const deferred = $q.defer();

        $http.get(_url).then((results) => {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getProductCategories = function (geoState, programId) {
        const deferred = $q.defer();

        if (angular.isDefined(_productCategories[geoState])) {
            deferred.resolve(_productCategories[geoState]);
            return deferred.promise;
        }

        _getProductCategories(geoState, programId).then((results) => {
            _productCategories[geoState] = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    // END Product Categories


    // Geo State
    let _geoStates;
    const _getGeoStates = function (request) {
        const _url = `${serviceBase}ProductLookup/GetGeoStates`;
        const deferred = $q.defer();
        $http.get(_url).then((results) => {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getGeoStates = function (request) {
        const deferred = $q.defer();

        if (angular.isDefined(_geoStates)) {
            deferred.resolve(_geoStates);
            return deferred.promise;
        }

        _getGeoStates(request).then((results) => {
            _geoStates = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    // END Geo State


    // Product Search
    let _productSearch;
    const _getProductSearch = function (request) {
        const _url = `${serviceBase}ProductLookup/ProductSearch`;
        const deferred = $q.defer();
        $http.post(_url, request).then((results) => {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getProductSearch = function (request) {
        const deferred = $q.defer();

        _getProductSearch(request).then((results) => {
            _productSearch = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    // END Product Search

    // Product Type Search
    let _productTypeSearch;
    const _getProductTypeSearch = function (request) {
        const _url = `${serviceBase}ProductLookup/ProductTypeSearch?searchTerm=${request.searchTerm}&StateGeoAbbreviation=${geoStateCacheService.getCurrentStateObject().StateAbbreviation}`;
        const deferred = $q.defer();
        $http.get(_url).then((results) => {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getProductTypeSearch = function (request) {
        const deferred = $q.defer();

        _getProductTypeSearch(request).then((results) => {
            _productTypeSearch = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    // END Product Type Search

    // Product Filters
    let _productFilters;
    const _getProductFilters = function (productTypeId) {
        const _url = `${serviceBase}ProductLookup/ProductFilters?ProductTypeId=${productTypeId}`;
        const deferred = $q.defer();

        $http.get(_url).then((results) => {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getProductFilters = function (productID) {
        const deferred = $q.defer();

        _getProductFilters(productID).then((results) => {
            _productFilters = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    // END Product Filters

    // Product Info
    let _productInfo;
    const _getProductInfo = function (productTypeId, productID) {
        let _url = `${serviceBase}ProductLookup/ProductInfo?ProductTypeId=${productTypeId}${productID ? `&ProductId=${productID}` : ''}`;
        _url += `&geoState=${geoStateCacheService.getCurrentStateObject().StateAbbreviation}`;
        const deferred = $q.defer();

        $http.get(_url).then((results) => {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getProductInfo = function (productTypeId, productID) {
        const deferred = $q.defer();

        _getProductInfo(productTypeId, productID).then((results) => {
            _productInfo = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    // END Product Info

    // MFA Calculation
    let _MFAResult;
    const _getMFACalculation = function (request) {
        const _url = `${serviceBase}ProductLookup/MFACalculation`;
        const deferred = $q.defer();

        $http.post(_url, request).then((results) => {
            deferred.resolve(results);
        });

        return deferred.promise;
    };
    this.getMFACalculation = function (productTypeId, productID) {
        const deferred = $q.defer();

        _getMFACalculation(productTypeId, productID).then((results) => {
            _MFAResult = results;
            deferred.resolve(results);
        });

        return deferred.promise;
    };

    // END Calculation

    // Return data for specific input type
    this.getInputTypeByID = function (data, inputTypeID) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].TypeId === inputTypeID) {
                return data[i].InputOptions;
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/services/productLookupService.js